import { StyledAdditionalTypesSelector } from './AdditionalTypesSelector.style';
import useMenuItems from './useMenuItems';
import useAdditionalTypes from './useAdditionalTypes';
import FilterMenusV2 from 'components/FilterMenus/FilterMenusV2';

const AdditionalTypesSelector = ({ additionalTypes, setAdditionalTypes }) => {
  const { menuItemsV2 } = useMenuItems();

  const { selectedFilters, setSelectedFilters, isLoadingFilters } =
    useAdditionalTypes({ additionalTypes, setAdditionalTypes });
  return (
    <StyledAdditionalTypesSelector>
      <FilterMenusV2
        menuItems={menuItemsV2}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        isLoading={isLoadingFilters}
        buttonTitle='Add Dimension'
        supportAllFields={true}
      />
    </StyledAdditionalTypesSelector>
  );
};

export default AdditionalTypesSelector;
